module.exports = __webpack_public_path__ + "img/reportCoverImage.55d5fddc.png";